import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_interestedTalents = _resolveComponent("interestedTalents")!
  const _component_app_loader_talents = _resolveComponent("app-loader-talents")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_interestedTalents, { interested: _ctx.interested }, null, 8, ["interested"]),
    _createVNode(_component_app_loader_talents, {
      loading: _ctx.loading,
      resources: _ctx.interests,
      content: "Can't find any talents to match with."
    }, null, 8, ["loading", "resources"])
  ]))
}